"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateThemeJSON = exports.generateTypographyValues = exports.generateTypography = exports.generateTokens = exports.generateToken = void 0;
var param_case_1 = require("param-case");
var functions_1 = require("./functions");
var utils_1 = require("./utils");
// TODO: https://github.com/salute-developers/plasma/issues/512
/**
 * Генерация одиночного токена.
 * @param {TokenData<TokenType>} token Входные данные
 * @param {GeneratedTokenType} type Тип выводимого токена
 * @param {string} prefix Префикс в CSS-токене
 * @param {boolean} withType Генерировать типы для токенов
 * @return {string}
 */
var generateToken = function (_a) {
    var token = _a.token, type = _a.type, name = _a.name, prefix = _a.prefix, withType = _a.withType;
    var comment = token.comment;
    var value = token.value;
    var out = '';
    var typeHint = '';
    if (comment) {
        out += "/** ".concat(comment, " */\n");
    }
    if (withType) {
        var typeName = (0, functions_1.capitalize)(name);
        typeHint = ": ".concat(typeName);
        if (typeof value === 'string' || typeof value === 'number') {
            out += "type ".concat(typeName, " = ").concat(typeof value, ";");
        }
        else {
            out += "type ".concat(typeName, " = {\n").concat(Object.keys(value)
                .map(function (k) { return "    ".concat(k, ": any"); })
                .join(';\n'), ";\n};");
        }
        out += '\n\n';
    }
    if (typeof value === 'string') {
        // type=css param is used for colors values only
        if (type === 'css') {
            value = (0, functions_1.toCSSVarTokenWithValue)("".concat(prefix, "-").concat((0, param_case_1.paramCase)(name)), value);
        }
        else {
            value = (0, utils_1.escapeValue)(value);
        }
        out += "export const ".concat(name).concat(typeHint, " = '").concat(value, "';\n");
    }
    else {
        // type=css param is used for typography values only
        var replacer = function (k, val) {
            if (k) {
                return (0, functions_1.toCSSVarTokenWithValue)("".concat(prefix, "-").concat((0, param_case_1.paramCase)(k)), val);
            }
            return val;
        };
        var objToStr = (type === 'css' ? JSON.stringify(value, replacer, 4) : JSON.stringify(value, null, 4)).replace(/"/g, "'");
        out += "export const ".concat(name).concat(typeHint, " = ").concat(objToStr, ";");
    }
    return out;
};
exports.generateToken = generateToken;
/**
 * Преобразует объект токенов в CSS Properties object.
 * @param {TokenDataGroup<TokenType>} tokens Объект токенов
 * @param {GeneratedTokenType} type Тип выводимого токена
 * @param {string} prefix Префикс в CSS-токене
 * @param {boolean} withType Генерировать типы для токенов
 * @return {string}
 */
var generateTokens = function (tokens, type, prefix, withType) {
    if (type === void 0) { type = 'value'; }
    return Object.entries(tokens).reduce(function (acc, _a) {
        var name = _a[0], token = _a[1];
        return "".concat(acc).concat((0, exports.generateToken)({ token: token, type: type, name: name, prefix: prefix, withType: withType }), "\n");
    }, '');
};
exports.generateTokens = generateTokens;
/**
 * Генерация типографики, разложенной по типам компонентов.
 * @param {TypoSystem} Типографическая система
 * @return {GeneratedFiles}
 */
var generateTypography = function (typoStyles) {
    var out = [];
    var index = '';
    for (var _i = 0, _a = Object.entries(typoStyles); _i < _a.length; _i++) {
        var _b = _a[_i], name_1 = _b[0], styles = _b[1];
        index += "export { ".concat(name_1, " } from './").concat(name_1, "';\n");
        out.push({
            file: "".concat(name_1, ".ts"),
            content: (0, exports.generateToken)({
                token: { value: styles },
                type: 'css',
                name: name_1,
                prefix: "typo-".concat(name_1),
                withType: true,
            }),
        });
    }
    out.push({
        file: 'index.ts',
        content: index,
    });
    return out;
};
exports.generateTypography = generateTypography;
/**
 * Генерация параметрической системы на основе встречающихся значений типографики.
 * @param {TypoSystem} Типографическая система
 * @return {GeneratedFiles}
 */
var generateTypographyValues = function (typoSystem) {
    var fontSizes = typoSystem.fontSizes, fonts = typoSystem.fonts, fontWeights = typoSystem.fontWeights, lineHeights = typoSystem.lineHeights, letterSpacings = typoSystem.letterSpacings;
    var out = [];
    var index = '';
    for (var _i = 0, _a = Object.entries({
        fontSizes: fontSizes,
        fonts: fonts,
        fontWeights: fontWeights,
        lineHeights: lineHeights,
        letterSpacings: letterSpacings,
    }); _i < _a.length; _i++) {
        var _b = _a[_i], name_2 = _b[0], styles = _b[1];
        index += "export { ".concat(name_2, " } from './").concat(name_2, "';\n");
        out.push({
            file: "".concat(name_2, ".ts"),
            content: (0, exports.generateToken)({
                token: { value: styles },
                type: 'css',
                name: name_2,
                prefix: "typo-".concat(name_2),
            }),
        });
    }
    out.push({
        file: 'index.ts',
        content: index,
    });
    return out;
};
exports.generateTypographyValues = generateTypographyValues;
/**
 * Генерация Theme JSON.
 */
var generateThemeJSON = function (typoSystem, basicTheme, otherThemes) {
    var fontSizes = typoSystem.fontSizes, rest = __rest(typoSystem, ["fontSizes"]);
    // font-size is often first
    // https://system-ui.com/theme/
    var theme = __assign({ fontSizes: fontSizes, colors: __assign(__assign({}, basicTheme), { modes: otherThemes }) }, rest);
    return "".concat(JSON.stringify(theme, null, 4), "\n");
};
exports.generateThemeJSON = generateThemeJSON;
//# sourceMappingURL=generation.js.map